import { render, staticRenderFns } from "./ConspectUpdate.vue?vue&type=template&id=bb2b9618&"
import script from "./ConspectUpdate.vue?vue&type=script&lang=js&"
export * from "./ConspectUpdate.vue?vue&type=script&lang=js&"
import style0 from "./ConspectUpdate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ConspectUpdate.vue"
export default component.exports